(function () {
  'use strict';

  angular.module('app').service('TourContentModalService', TourContentModalService);

  TourContentModalService.$inject = ['ModalService'];

  function TourContentModalService(ModalService) {
    var service = {
      openTourContentsModal: openTourContentsModal,
      openTourContentTranslationsModal: openTourContentTranslationsModal,
    };

    return service;

    ////////////////

    // --------------------------- openTourContentsModal -------------------------

    function openTourContentsModal(tour) {
      ModalService.showModal({
        templateUrl: './app/ajs/tour-contents/modals/tour-contents-modal.html',
        controller: TourContentsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          tour: tour,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      TourContentsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'AbilityService',
        '$location',
        'TourService',
        'TourContentService',
        'SessionService',
        'tour',
      ];
    }

    function TourContentsModalCtrl(
      $element,
      UtilService,
      AbilityService,
      $location,
      TourService,
      TourContentService,
      SessionService,
      tour
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canShow: AbilityService.can('show_tour_accountadmin'),
        canCreate: AbilityService.can('create_tour_accountadmin'),
        canUpdate: AbilityService.can('update_tour_accountadmin'),
        canDestroy: AbilityService.can('destroy_tour_accountadmin'),
      };

      vm.tour = tour;
      vm.modalTitle = tour.name;

      // Methods
      vm.showContent = showContent;
      vm.deleteContent = deleteContent;
      vm.changeContentStatus = changeContentStatus;
      vm.changeContentPublished = changeContentPublished;
      vm.addContent = addContent;

      var companyWebsites = SessionService.getSelectedAccountCompany().websites;

      // Initializers
      setTourContents();
      setAvailableWebsites();

      function setTourContents() {
        vm.usedCompanyWebsites = [];

        var tourContents = [];

        if (vm.tour.tour_contents) {
          vm.tour.tour_contents.forEach(function (content) {
            for (var i = 0; i < companyWebsites.length; i++) {
              var companyWebsite = companyWebsites[i];
              if (content && companyWebsite.id === content.website_id) {
                content.website_name = companyWebsite.name;
                vm.usedCompanyWebsites.push(companyWebsite);
                break;
              }
            }

            tourContents.push(content);
          });
        }

        vm.tour.contents = tourContents;
      }

      function setAvailableWebsites() {
        vm.availableCompanyWebsites = [];

        for (var i = 0; i < companyWebsites.length; i++) {
          var companyWebsite = companyWebsites[i];
          var found = false;
          for (var j = 0; j < vm.usedCompanyWebsites.length; j++) {
            var usedCompanyWebsite = vm.usedCompanyWebsites[j];
            if (companyWebsite.id === usedCompanyWebsite.id) {
              found = true;
              break;
            }
          }

          if (!found) {
            vm.availableCompanyWebsites.push(companyWebsite);
          }
        }
      }

      function getTour() {
        TourService.getTour(tour.id).then(function (data) {
          vm.tour = data;

          setTourContents();
          setAvailableWebsites();
        });
      }

      function showContent(content) {
        if (!vm.permissions.canShow) {
          return;
        }

        setTimeout(function () {
          // Delay x sec
          $location.path(`/tour_contents/${content.id}`).search({ WSID: content.website_id });
        }, 100);

        $element.modal('hide'); // bootstrap fade
      }

      function deleteContent(content) {
        TourContentService.deleteTourContent(content, getTour);
      }

      function changeContentStatus(content) {
        TourContentService.changeTourContentStatus(content);
      }

      function changeContentPublished(content) {
        TourContentService.changeTourContentPublished(content);
      }

      function addContent() {
        if (!vm.permissions.canCreate) {
          return;
        }

        setTimeout(function () {
          // Delay x sec
          $location
            .path(`/tour_contents/new`)
            .search({ WSID: vm.website.id, transportationId: vm.transportation.id });
        }, 100);

        $element.modal('hide'); // bootstrap fade
      }
    }

    // --------------------------- openTourContentTranslationsModal -------------------------

    function openTourContentTranslationsModal(itemId, websiteName, additionalLanguages) {
      ModalService.showModal({
        templateUrl: './app/ajs/tour-contents/modals/tour-content-detail-translation.html',
        controller: TourContentTranslationsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          itemId: itemId,
          websiteName: websiteName,
          additionalLanguages: additionalLanguages,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      TourContentTranslationsModalCtrl.$inject = [
        'UtilService',
        'TourContentService',
        'TagService',
        'itemId',
        'websiteName',
        'additionalLanguages',
      ];
    }

    function TourContentTranslationsModalCtrl(
      UtilService,
      TourContentService,
      TagService,
      itemId,
      websiteName,
      additionalLanguages
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.additionalLanguages = additionalLanguages;

      // Methods
      vm.getContent = getContent;
      vm.updateItem = updateItem;

      vm.tagTransform = tagTransform;
      vm.checkTagOptions = checkTagOptions;

      // Initializers
      getContent(additionalLanguages[0].lang);

      function getContent(language) {
        TourContentService.getTourContent(itemId, language).then(function (data) {
          vm.item = data;

          vm.modalTitle = vm.item.name + ' (' + websiteName + ')';

          vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);

          vm.languageSelected = language;

          getTags(language);
        });
      }

      function updateItem(isFormValid, language) {
        vm.formErrors = false;

        var to = 'translation_form';

        if (!isFormValid) {
          vm.serverErrors = [];

          vm.formErrors = true;
          vm.UtilService.scrollToTop(to);

          return;
        }

        vm.sendingForm = true;

        // console.log(vm.item, language); return;

        TourContentService.saveTourContent(vm.item, language).then(function (response) {
          if (response.errors) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);

            vm.formErrors = true;
            vm.UtilService.scrollToTop(to);
          }

          vm.sendingForm = false;
        });
      }

      // ----- TAGS ----- //

      function getTags(lang) {
        TagService.getTags({ skip_check_role: true, by_lang: lang }).then(function (data) {
          vm.tags = data.items;
        });
      }

      function tagTransform(name) {
        return TagService.tagTransform(name, vm.languageSelected);
      }

      function checkTagOptions(tag) {
        vm.tagOptions = TagService.checkTagOptions(tag, vm.tags);
      }
    }
  }
})();
